import { AppRoutes } from '@/utils/routes/router';

/**
 * Clerk `routing="path"` sub-routes (verify email, MFA, choose-organization task, etc.).
 * Do not redirect signed-in users away — Clerk must finish these steps first.
 */
export function isClerkHostedAuthSubRoute(pathname: string): boolean {
  return pathname.startsWith(`${AppRoutes.signIn}/`) || pathname.startsWith(`${AppRoutes.signUp}/`);
}

/**
 * Any sign-in / sign-up path, including the bare `/sign-in` and `/sign-up` entry URLs.
 * After OTP, Clerk may briefly land on bare `/sign-up` before `/sign-up/tasks/...` —
 * treating only `startsWith('/sign-up/')` as in-progress caused a redirect race that
 * canceled choose-organization (HAR status 0) and dumped users on `/` or `/dashboard`.
 */
export function isClerkAuthFlowPath(pathname: string): boolean {
  return (
    pathname === AppRoutes.signIn ||
    pathname.startsWith(`${AppRoutes.signIn}/`) ||
    pathname === AppRoutes.signUp ||
    pathname.startsWith(`${AppRoutes.signUp}/`)
  );
}

export function isClerkChooseOrganizationTaskPath(pathname: string): boolean {
  return pathname.includes('/tasks/choose-organization');
}

/** Bare landing/auth entry pages (`/`, `/landing`, `/waitlist`, `/sign-in`, `/sign-up`). */
export function isClerkAuthLandingPath(pathname: string): boolean {
  return (
    pathname === AppRoutes.home ||
    pathname === AppRoutes.landing ||
    pathname === AppRoutes.waitlist ||
    pathname === AppRoutes.signIn ||
    pathname === AppRoutes.signUp
  );
}
